/**
 * Keeps Kaching .kaching-cart-item__total-old aligned with offer-card compare prices.
 * Skips on PDP when inline script in el-product-form.liquid is active.
 */
(function () {
  "use strict";

  if (window.__elCompareFixOwner === "inline") return;

  var STORAGE_KEY = "elOfferCompares";
  var BOGO_PATTERN = /buy\s*(\d+)\s*,?\s*get\s*\1\s*free/i;
  var debounceTimer = null;
  var cartCache = null;
  var cartCacheAt = 0;
  var isApplying = false;
  var DEBUG = false;
  var LOG = "[el-compare-fix:asset]";

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, [LOG].concat(Array.prototype.slice.call(arguments)));
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    var amount = parseFloat(String(text).replace(/[^0-9.]/g, ""));
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var format =
        window.Shopify.money_format ||
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.theme && window.Shopify.theme.moneyFormat);
      return window.Shopify.formatMoney(cents, format);
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function normalizeMoneyText(text) {
    return String(text || "").replace(/[\u2066-\u2069\u200e\u200f]/g, "").trim();
  }

  function getCompareMapFromCards() {
    var map = {};

    document.querySelectorAll(".product-offer__variant-item[data-quantity][data-compare]").forEach(function (card) {
      if (card.dataset.compare) {
        map[card.dataset.quantity] = card.dataset.compare;
      }
    });

    return map;
  }

  function persistCompareMap(map) {
    if (!Object.keys(map).length) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (err) {
      /* ignore */
    }
  }

  function getCompareMap() {
    var map = {};
    var raw = null;
    var form = document.querySelector(".product-offer__form[data-offer-compares]");

    if (form?.dataset?.offerCompares && form.dataset.offerCompares !== "{}") {
      raw = form.dataset.offerCompares;
    }

    if (!raw) {
      var jsonEl = document.getElementById("el-offer-compares-json");
      if (jsonEl?.textContent?.trim()) {
        raw = jsonEl.textContent.trim();
      }
    }

    if (!raw) {
      try {
        raw = sessionStorage.getItem(STORAGE_KEY);
      } catch (err) {
        raw = null;
      }
    }

    if (raw) {
      try {
        map = JSON.parse(raw);
      } catch (err) {
        map = {};
      }
    }

    if (!Object.keys(map).length) {
      map = getCompareMapFromCards();
    }

    if (!Object.keys(map).length && window.elOfferCompareMap) {
      map = window.elOfferCompareMap;
    }

    persistCompareMap(map);
    return map;
  }

  function getDrawerRoot() {
    var drawer = document.querySelector("kaching-cart-drawer, #cart-drawer");
    if (!drawer) return null;
    return drawer.shadowRoot || drawer;
  }

  function parseBogoQty(text) {
    var match = String(text || "").match(BOGO_PATTERN);
    if (!match) return null;
    return Number(match[1]) * 2;
  }

  function getDrawerDiscountQty() {
    var drawer = document.querySelector("kaching-cart-drawer, #cart-drawer");
    if (!drawer) return null;

    var badgeText = drawer.querySelector(".kaching-cart__cart-discounts-badge span")?.textContent;
    return parseBogoQty(badgeText);
  }

  function isFreeContainer(container) {
    if (container.getAttribute("data-kaching-static-free") === "true") return true;
    if (container.classList.contains("kaching-cart-item-container--free")) return true;

    var finalEl = container.querySelector(".kaching-cart-item__total-final");
    return !!(finalEl && /free/i.test(normalizeMoneyText(finalEl.textContent)));
  }

  function getQtyFromInput(container) {
    var qtyInput = container.querySelector(".kaching-cart-item__quantity-input");
    if (!qtyInput) return null;

    var value = qtyInput.value || qtyInput.getAttribute("value");
    if (value && Number(value) > 0) return Number(value);

    return null;
  }

  function findCartLineForContainer(container, cart) {
    if (!cart?.items?.length) return null;

    var itemEl = container.querySelector(".kaching-cart-item");
    var productId = itemEl?.dataset?.productId;
    var handle = itemEl?.dataset?.productHandle;

    var paidLines = cart.items.filter(function (line) {
      return line.final_line_price > 0 || line.line_price > 0;
    });

    if (productId) {
      var byProduct = paidLines.find(function (line) {
        return String(line.product_id) === String(productId);
      });
      if (byProduct) return byProduct;
    }

    if (handle) {
      var byHandle = paidLines.find(function (line) {
        return line.handle === handle;
      });
      if (byHandle) return byHandle;
    }

    return paidLines[0] || cart.items[0] || null;
  }

  function resolveQty(container, cart) {
    var fromInput = getQtyFromInput(container);
    if (fromInput) return fromInput;

    var line = findCartLineForContainer(container, cart);
    if (line?.quantity) return line.quantity;

    var discountQty = getDrawerDiscountQty();
    if (discountQty) return discountQty;

    return parseBogoQty(container.textContent);
  }

  function updateSavingsLabel(container, compareCents, finalCents) {
    var saveCents = compareCents - finalCents;
    if (saveCents <= 0) return;

    var saveText = "You save " + formatMoney(saveCents);

    container.querySelectorAll(".kaching-cart__badge span").forEach(function (span) {
      if (/you save/i.test(span.textContent) && normalizeMoneyText(span.textContent) !== saveText) {
        span.textContent = saveText;
      }
    });
  }

  function injectCompareStyles(root) {
    if (!root || root.querySelector("#el-kaching-compare-styles")) return;
    var style = document.createElement("style");
    style.id = "el-kaching-compare-styles";
    style.textContent =
      ".kaching-cart-item__total-old[data-el-hidden-by-origin='1'] { display: none !important; }" +
      "s.el-kaching-compare-static, .el-kaching-compare-static { text-decoration: line-through; margin-right: 0.35em; color: rgba(var(--kaching-cart-line-items-text-2)); font-weight: 400; white-space: nowrap; }";
    root.insertBefore(style, root.firstChild);
  }

  function applyStaticCompare(container, formatted) {
    var oldEl = container.querySelector("s.kaching-cart-item__total-old, .kaching-cart-item__total-old:not(.el-kaching-compare-static)");
    if (!oldEl) return false;

    oldEl.setAttribute("data-el-hidden-by-origin", "1");

    var finalEl = container.querySelector(".kaching-cart-item__total-final");
    var staticEl = container.querySelector(".el-kaching-compare-static");

    if (!staticEl) {
      staticEl = document.createElement("s");
      staticEl.className = "el-kaching-compare-static";
      if (finalEl && finalEl.parentNode) {
        finalEl.parentNode.insertBefore(staticEl, finalEl);
      } else if (oldEl.parentNode) {
        oldEl.parentNode.insertBefore(staticEl, oldEl.nextSibling);
      } else {
        return false;
      }
    }

    if (staticEl.textContent !== formatted) {
      staticEl.textContent = formatted;
      log("static compare shown", { price: formatted });
    }

    return true;
  }

  function fixContainerCompare(container, compareMap, cart) {
    if (isFreeContainer(container)) return false;

    var qty = resolveQty(container, cart);
    if (!qty) return false;

    var compareText = compareMap[String(qty)];
    if (!compareText) return false;

    var compareCents = parseMoneyToCents(compareText);
    if (!compareCents) return false;

    var formatted = normalizeMoneyText(compareText) || formatMoney(compareCents);
    if (!applyStaticCompare(container, formatted)) return false;

    var finalEl = container.querySelector(".kaching-cart-item__total-final");
    var finalCents = parseMoneyToCents(normalizeMoneyText(finalEl?.textContent));
    if (finalCents != null) {
      updateSavingsLabel(container, compareCents, finalCents);
    }

    container.dataset.elCompareFixed = "1";
    return true;
  }

  function runFix(cart, compareMap, root) {
    var containers = root.querySelectorAll(".kaching-cart-item-container");
    var anyChanged = false;

    containers.forEach(function (container) {
      if (fixContainerCompare(container, compareMap, cart)) {
        anyChanged = true;
      }
    });

    return anyChanged;
  }

  function applyComparePrices(forceFetch) {
    var compareMap = getCompareMap();
    if (!Object.keys(compareMap).length) return Promise.resolve();

    var root = getDrawerRoot();
    if (!root) return Promise.resolve();

    if (isApplying) return Promise.resolve();
    isApplying = true;

    function finish(cart) {
      injectCompareStyles(root);
      runFix(cart, compareMap, root);
      isApplying = false;
    }

    if (!forceFetch && cartCache && Date.now() - cartCacheAt < 3000) {
      finish(cartCache);
      return Promise.resolve();
    }

    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cartCache = cart;
        cartCacheAt = Date.now();
        finish(cart);
      })
      .catch(function () {
        finish(cartCache);
      });
  }

  function scheduleApply(forceFetch) {
    clearTimeout(debounceTimer);
    applyComparePrices(forceFetch);
    debounceTimer = setTimeout(function () {
      applyComparePrices(forceFetch);
    }, 300);
  }

  function clearFixedMarkers(root) {
    if (!root) return;
    root.querySelectorAll(".el-kaching-compare-static").forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll("[data-el-hidden-by-origin]").forEach(function (el) {
      el.removeAttribute("data-el-hidden-by-origin");
    });
    root.querySelectorAll("[data-el-compare-fixed]").forEach(function (el) {
      delete el.dataset.elCompareFixed;
    });
  }

  function attachDrawerObserver(drawer) {
    if (!drawer || drawer.dataset.elCompareObserver === "true") return;

    drawer.dataset.elCompareObserver = "true";
    log("drawer observer attached");

    var observeTarget = drawer.shadowRoot || drawer;
    injectCompareStyles(observeTarget);

    new MutationObserver(function () {
      scheduleApply(false);
    }).observe(observeTarget, {
      childList: true,
      subtree: true
    });

    if (drawer.shadowRoot) {
      new MutationObserver(function () {
        if (drawer.hasAttribute("open")) {
          scheduleApply(true);
        }
      }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
    }
  }

  function hookCartFetch() {
    if (window.__elCompareFetchHooked) return;
    window.__elCompareFetchHooked = true;

    var originalFetch = window.fetch.bind(window);

    window.fetch = function () {
      var url = String(arguments[0] || "");

      return originalFetch.apply(window, arguments).then(function (response) {
        if (/\/cart(\.js|\/add|\/change|\/update|\/clear)/.test(url)) {
          cartCache = null;
          var root = getDrawerRoot();
          clearFixedMarkers(root);
          scheduleApply(true);
        }

        return response;
      });
    };
  }

  function hookKachingRefresh() {
    if (window.__elCompareRefreshHooked || !window.kachingCartApi?.refreshCart) return;
    window.__elCompareRefreshHooked = true;

    var originalRefresh = window.kachingCartApi.refreshCart.bind(window.kachingCartApi);

    window.kachingCartApi.refreshCart = function () {
      cartCache = null;
      var root = getDrawerRoot();
      clearFixedMarkers(root);

      return originalRefresh.apply(window.kachingCartApi, arguments).then(function (result) {
        scheduleApply(true);
        return result;
      });
    };
  }

  function init() {
    log("init");
    getCompareMap();
    hookCartFetch();
    hookKachingRefresh();
    attachDrawerObserver(document.querySelector("kaching-cart-drawer, #cart-drawer"));

    new MutationObserver(function () {
      attachDrawerObserver(document.querySelector("kaching-cart-drawer, #cart-drawer"));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("cart:updated", function () {
    cartCache = null;
    scheduleApply(true);
  });

  document.addEventListener("cart:change", function () {
    cartCache = null;
    scheduleApply(true);
  });

  window.elApplyKachingComparePrices = function () {
    return applyComparePrices(true);
  };
})();
